import { HelpCircle } from "lucide-react";
import { type ReactNode } from "react";
import CleModal, { CleModalRoot, CleModalTrigger } from "./CleModal";

export type InfoModalProps = {
  ariaLabel?: string;
  children: ReactNode;
  description?: string;
  title: ReactNode;
};

const InfoModal = ({
  ariaLabel,
  children,
  description,
  title,
}: InfoModalProps) => {
  const fallbackAriaLabel =
    typeof title === "string" ? `Læs mere om ${title}` : "Læs mere";

  return (
    <CleModalRoot>
      <CleModalTrigger asChild>
        <button
          type="button"
          className="cle-info-modal__trigger"
          aria-label={ariaLabel ?? fallbackAriaLabel}
        >
          <HelpCircle size={22} aria-hidden strokeWidth={1.75} />
        </button>
      </CleModalTrigger>
      {/* Deliberately no description fallback: the aria-label ("Læs mere om X")
          is right for the button but useless as the dialog's description — a
          screen reader would announce the title and then repeat it. Modal omits
          Dialog.Description entirely when description is undefined. */}
      <CleModal title={title} description={description} size="sm">
        <div className="text-muted">{children}</div>
      </CleModal>
    </CleModalRoot>
  );
};

export default InfoModal;
